/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';

const JoinUsSection: React.FC = () => {
  const Image = require('../../../assets/images/image.jpg');

  return (
    <section
      id="join-us"
      className="relative overflow-hidden bg-[#03010E] text-white flex items-center justify-center"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70"
        style={{ backgroundImage: `url(${Image})` }}
      />

      <div className="absolute inset-0 bg-gradient-to-t from-[#03010E] via-[#021822]/90 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#03010E]/80 via-transparent to-[#03010E]" />

      <div className="relative container mx-auto px-6 md:px-12 py-44 text-center z-20">
        <h2 className="text-3xl md:text-5xl font-extrabold leading-snug">
          Join us in driving something{' '}
          <span className="text-[#00D4FF] drop-shadow-[0_0_25px_rgba(0,212,255,0.6)]">
            Revolutionary.
          </span>
        </h2>
        <p className="mt-4 text-[#C7E6F5] text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
          Be part of a movement redefining the future of occupational hygiene through innovation,
          collaboration, and technology.
        </p>

        <a
          href="#contact"
          className="
    inline-flex items-center gap-2 mt-10 px-10 py-4
    bg-[#00D4FF] text-black font-semibold rounded-full
    hover:bg-[#00b8e6]
    transition-all duration-300
    shadow-[0_0_25px_rgba(0,212,255,0.5)]
    no-underline
  "
          style={{ textDecoration: 'none' }}
        >
          Reach Out
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default JoinUsSection;
